<template>
  <div class="signUp-page">
    <signUpForm></signUpForm>
  </div>
</template>

<script>
import signUpForm from '../components/signUpForm'
export default {
  name: 'signUp-page',
  components: { signUpForm }
}
</script>

<style scoped lang="less">
  @import "../less/variable";
  @mainRed: #C13B4D;
  .signUp-page {
    min-height: 100vh;
    width: 100%;
    background-color: #fff;
    color: #333;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/pages/signUp.vue